<div class="ui-tabview ui-widget ui-widget-content ui-tabview-top mb-3 task-tab-bar">
  <ul
    class="ui-tabview-nav ui-helper-reset ui-helper-clearfix ui-widget-header"
    style="padding-left: 0"
  >
    <li
      *ngFor="let task of tasks; let i = index"
      (click)="clickedTask(task.id)"
      [class.ui-state-active]="task.id == selectedTaskId"
      [class.ui-state-default]="task.id != selectedTaskId"
    >
      <a> {{ task.regNumber }} </a>
    </li>
  </ul>
</div>

<div *ngFor="let task of tasks; let i = index">
  <ng-container
    [ngTemplateOutlet]="taskScreen"
    [ngTemplateOutletContext]="{ task, visible: task.id == selectedTaskId }"
  ></ng-container>
</div>

<ng-template #taskScreen let-containerTask="task" let-visible="visible">
  <div style="padding: 0 20px" [hidden]="!visible">
    <div
      style="display: flex; flex-wrap: wrap; grid-gap: 15px; margin-top: 15px"
      class="sm:flex-wrap md:flex-nowrap"
    >
      <div style="flex-basis: 310px; flex-grow: 1; min-width: 310px">
        <job-screen-model-pin
          [organisationTypeId]="organisationTypeId"
          [modelPinTask]="selectedTask?.modelPin"
          [jobId]="containerTask.jobId"
          [orderId]="containerTask.orderId"
        ></job-screen-model-pin>

        <job-screen-release-code
          [organisationTypeId]="organisationTypeId"
          [releaseCodeTask]="selectedTask?.releaseCode"
          [jobId]="containerTask.jobId"
          [orderId]="containerTask.orderId"
        ></job-screen-release-code>

        <job-screen-site-opening
          [organisationTypeId]="organisationTypeId"
          [taskId]="containerTask.id"
        ></job-screen-site-opening>

        <job-screen-customer-task-window
          [taskId]="containerTask.id"
        ></job-screen-customer-task-window>
      </div>
      <div style="flex-grow: 100">
        <job-screen-checklist [organisationTypeId]="organisationTypeId" [taskId]="containerTask.id">
        </job-screen-checklist>

        <div class="mt-3">
          <job-screen-vehicle-information
            [organisationTypeId]="organisationTypeId"
            [taskId]="containerTask.id"
          ></job-screen-vehicle-information>
        </div>
      </div>
    </div>
  </div>
</ng-template>
